/**
 * Web Style Import
 *
 */

import './dnb-flex.scss'
